export const WhatsappOutlineSVG = (props) => (
  <svg height="34" viewBox="0 0 34 34" width="34" xmlns="http://www.w3.org/2000/svg"
  {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round"
      transform="translate(1 1)"
    >
      <path
        d="m16.2901429 0c-8.67550004 0-15.7091429 6.97864286-15.7091429 15.588 0 2.945.82371429 5.6992857 2.25421429 8.0490714l-2.83521429 8.3629286 8.69742857-2.763c2.25057143 1.2346429 4.83892853 1.939 7.59271433 1.939 8.6766428 0 15.7098571-6.9796429 15.7098571-15.588 0-8.60935714-7.0332143-15.588-15.7098571-15.588z"
        stroke="#000"
      />
      <path
        d="m12.327437 19.7504541c2.4165353 2.3828183 5.5087682 4.3985967 7.4528131 4.2408736 3.66248-.2973432 4.8923582-4.8000326 4.8923582-4.8000326l-4.2408735-2.3475173-1.4129457 1.5803992s-.8553706.9868443-1.752831.2260622c-.3120519-.264305-1.1590499-1.1841679-1.9334093-1.9476654-.7743594-.7634976-1.7059893-1.5975971-1.9745938-1.9058021-.7734542-.8868248.2011705-1.7557728.2011705-1.7557728l1.5607121-1.4351219-2.8114088-4.605877s-4.27255397.84971347-4.32641065 5.3580601c-.02330772 1.9503809 1.92865724 5.0095757 4.34541885 7.392394z"
        stroke="#1d1d1b"
      />
    </g>
  </svg>
);
